// extracted by mini-css-extract-plugin
export var chevronIcon = "_6d-2";
export var teamName = "_6d-1";
export var teamSwitcherButton = "_6d-0";